import CloseOutlined from '@ant-design/icons/lib/icons/CloseOutlined';
import { Button, type ButtonProps, Drawer, Modal } from 'antd';

import { useWindowWidth } from '@/hooks/useWindowWidth';
import { cn } from '@/lib/cn';

export const Modrawer = ({
  open,
  cancelText,
  okText,
  width,
  height,
  cancelButtonProps,
  okButtonProps,
  onCancel,
  onOk,
  title,
  children,
  footer,
  footerWrapperClassname,
  full = false,
  breakpoint = 768
}: {
  open: boolean;
  okText?: React.ReactNode;
  cancelText?: React.ReactNode;
  width?: number;
  height?: number;
  onCancel?: () => void;
  onOk?: () => void;
  title?: React.ReactNode;
  children?: React.ReactNode;
  cancelButtonProps?: ButtonProps;
  footerWrapperClassname?: string;
  okButtonProps?: ButtonProps;
  footer?: React.ReactNode;
  full?: boolean;
  breakpoint?: number;
}) => {
  const windowWidth = useWindowWidth();

  if (windowWidth > breakpoint) {
    return (
      <Modal
        cancelButtonProps={{ ...cancelButtonProps, className: 'override-button-base!' }}
        okButtonProps={{ ...okButtonProps, className: 'override-button-base!' }}
        open={open}
        okText={okText}
        cancelText={cancelText}
        width={width}
        height={height}
        onCancel={onCancel}
        onOk={onOk}
        title={title}
        footer={footer}
        closeIcon={<CloseOutlined id='modrawer-close-button' />}
      >
        {children}
      </Modal>
    );
  }

  return (
    <Drawer
      title={title}
      placement='bottom'
      width={width || '100%'}
      onClose={onCancel}
      // eslint-disable-next-line eduzz-rules/jsx-valid-id
      closeIcon={<CloseOutlined id='modrawer-close-button' />}
      open={open}
      styles={{
        content: { padding: 0 },
        body: {
          padding: 24,
          maxHeight: 'none',
          overflow: 'visible'
        }
      }}
      height={full ? '100%' : 'auto'}
    >
      <div className='flex h-full flex-1 flex-col'>
        {children}
        <div className='flex flex-1'></div>
        {footer && <div className='mt-4'>{footer}</div>}
        {!footer && (
          <div className={cn('mt-4 flex justify-end gap-2', footerWrapperClassname)}>
            <Button className='override-button-base!' id='cancel' onClick={onCancel} {...cancelButtonProps}>
              {cancelText || 'Cancel'}
            </Button>
            <Button className='override-button-base!' id='ok' type='primary' onClick={onOk} {...okButtonProps}>
              {okText || 'OK'}
            </Button>
          </div>
        )}
      </div>
    </Drawer>
  );
};
